module.exports = __webpack_public_path__ + "static/img/kong.358a2b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/kong.png
// module id = kl3H
// module chunks = 96